import { atom } from 'recoil';

const userInfo = atom<User.Auth.UserInfo | null>({
  key: 'userInfo',
  default: null,
});

export default userInfo;
